import ZendeskListIcon from '../../assets/img/integration-list/zendesk-integration-list-icon.svg';
import TrengoListIcon from '../../assets/img/integration-list/trengo-integration-list-icon.svg';
import SlackListIcon from '../../assets/img/integration-list/slack-integration-list-icon.svg';
import FreshdeskIcon from '../../assets/img/integration-list/freshdesk-integration-list-icon.svg';
import ZendeskChat from '../../assets/img/integration-list/zendesk-chat-integration-list-icon.svg';
import ZendeskEmail from '../../assets/img/integration-list/zendesk-email-integration-list-icon.svg';
import ZohoChat from '../../assets/img/integration-list/zoho-chat-integration-list-icon.svg';
import FreshdeskChat from '../../assets/img/integration-list/freshdesk-chat-integration-list-icon.svg';
import FreshdeskEmail from '../../assets/img/integration-list/freshdesk-email-integration-list-icon.svg';
import ZohoEmail from '../../assets/img/add-integration/add-integration-zoho-email-icon.svg';
import { SETUP_GUIDE_URL } from 'src/constants/urls';

export const IntegrationTypeAgent = [
  {
    friendlyName: 'Zendesk',
    icon: ZendeskListIcon,
    setupGuideUrl: null,
    setupSteps: 2,
    data: {
      integration_type: 'zendesk',
      integration_data: {
        subdomain: '',
        credits: 0,
        api_token: '',
        auth_email: '',
        via_email: true,
        via_chat: true,
      },
    },
  },
  {
    friendlyName: 'Freshdesk',
    icon: FreshdeskIcon,
    setupGuideUrl: null,
    setupSteps: 2,
    data: {
      integration_type: 'freshdesk',
      integration_data: {
        subdomain: '',
        api_key: '',
      },
    },
  },
  {
    friendlyName: 'Trengo',
    icon: TrengoListIcon,
    setupGuideUrl: null,
    setupSteps: 2,
    data: {
      integration_type: 'trengo',
      integration_data: {
        agency_id: '',
      },
    },
  },
];

export const IntegrationTypeCustomer = [
  {
    friendlyName: 'Zendesk Chat',
    icon: ZendeskChat,
    setupSteps: 4,
    setupGuideUrl: SETUP_GUIDE_URL.ZENDESK_CHAT,
    data: {
      integration_type: 'zendesk_chat',
      integration_data: {
        project_name: '',
        subdomain: '',
        author_display_name: '',
        author_avatar_url: '',
        app_id: '',
        conversation_key_id: '',
        conversation_secret_key: '',
      },
    },
  },
  {
    friendlyName: 'Zendesk Email',
    icon: ZendeskEmail,
    setupSteps: 5,
    setupGuideUrl: SETUP_GUIDE_URL.ZENDESK_EMAIL,
    data: {
      integration_type: 'zendesk_email',
      integration_data: {
        project_name: '',
        email: '',
        subdomain: '',
        api_key: '',
      },
    },
  },
  {
    friendlyName: 'Freshchat',
    icon: FreshdeskChat,
    setupSteps: 3,
    setupGuideUrl: SETUP_GUIDE_URL.FRESHCHAT,
    data: {
      integration_type: 'freshdesk_chat',
      integration_data: {
        name: '',
        chat_url: '',
        api_key: '',
        webhook_api_token: '',
      },
    },
  },
  {
    friendlyName: 'Freshdesk',
    icon: FreshdeskEmail,
    setupSteps: 4,
    setupGuideUrl: SETUP_GUIDE_URL.FRESHDESK_EMAIL,
    data: {
      integration_type: 'freshdesk_email',
      integration_data: {
        name: '',
        subdomain: '',
        api_key: '',
      },
    },
  },
  {
    friendlyName: 'Zoho SalesIQ',
    icon: ZohoChat,
    setupSteps: 2,
    setupGuideUrl: SETUP_GUIDE_URL.ZOHO_SALES_IQ,
    data: {
      integration_type: 'zoho_salesiq',
      integration_data: {
        project_name: '',
      },
    },
  },
  {
    friendlyName: 'Zoho Desk',
    icon: ZohoEmail,
    setupSteps: 3,
    setupGuideUrl: SETUP_GUIDE_URL.ZOHODESK_EMAIL,
    data: {
      integration_type: 'zoho_desk',
      integration_data: {
        name: '',
        client_id: '',
        client_secret: '',
        scope: '',
        server_locale: '',
        code: '',
        refresh_token: '',
      },
    },
  },
  // {
  //   friendlyName: 'Slack',
  //   icon: SlackListIcon,
  //   setupSteps: 2,
  //   setupGuideUrl: null,
  //   data: {
  //     integration_type: 'slack',
  //     integration_data: {
  //       domain: '',
  //       project_name: '',
  //     },
  //   },
  // },
];

export const IntegrationTypeBi = [
  {
    friendlyName: 'Slack',
    icon: SlackListIcon,
    setupSteps: 2,
    setupGuideUrl: null,
    data: {
      integration_type: 'slack',
      integration_data: {
        domain: '',
        project_name: '',
      },
    },
  },
];
